import { useRef } from 'react';
import { Icon } from '@capsico/ui';

/** Gate photo: dashed add tile, or the preview with Replace / Remove and an upload bar. */
export function PhotoField({
  labels,
  url,
  uploading,
  onFile,
  onRemove,
}: {
  labels: {
    title: string;
    hint: string;
    add: string;
    replace: string;
    remove: string;
    uploading: (percent: number) => string;
  };
  url: string | null;
  uploading: number | null;
  onFile: (file: File) => void;
  onRemove: () => void;
}) {
  const input = useRef<HTMLInputElement>(null);
  const pick = () => input.current?.click();
  return (
    <div>
      <p className="text-sm font-semibold text-ink">{labels.title}</p>
      <p className="text-xs text-ink-3">{labels.hint}</p>
      <input
        ref={input}
        type="file"
        accept="image/*"
        capture="environment"
        className="hidden"
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) onFile(file);
          event.target.value = '';
        }}
      />
      {url ? (
        <div className="mt-2 flex items-center gap-3">
          <img src={url} alt="" className="size-20 rounded-xl object-cover" />
          <div className="min-w-0 flex-1">
            {uploading !== null ? (
              <>
                <p className="text-xs text-ink-2 tabular">{labels.uploading(uploading)}</p>
                <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-tile">
                  <div
                    className="h-full bg-brand-600 transition-[width]"
                    style={{ width: `${uploading}%` }}
                  />
                </div>
              </>
            ) : (
              <div className="flex gap-4 text-sm font-semibold">
                <button type="button" onClick={pick} className="text-brand-ink">
                  {labels.replace}
                </button>
                <button type="button" onClick={onRemove} className="text-negative">
                  {labels.remove}
                </button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <button
          type="button"
          onClick={pick}
          className="mt-2 flex h-20 w-full items-center justify-center gap-2 rounded-xl border-[1.5px] border-dashed border-brand-600 bg-brand-soft text-sm font-semibold text-brand-ink"
        >
          <Icon name="camera" size={18} />
          {labels.add}
        </button>
      )}
    </div>
  );
}
